module.exports = __webpack_public_path__ + "img/f5.a8ad03df.jpg";